import { render, staticRenderFns } from "./MessageSenderSelect.vue?vue&type=template&id=9e152b98&scoped=true"
import script from "./MessageSenderSelect.vue?vue&type=script&lang=js"
export * from "./MessageSenderSelect.vue?vue&type=script&lang=js"
import style0 from "./MessageSenderSelect.vue?vue&type=style&index=0&id=9e152b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e152b98",
  null
  
)

export default component.exports